module.exports = __webpack_public_path__ + "media/images/gbs-connect-ico-42d035149a8ef78b7dd471d4536c6e0c.png";